import { fetchWithHeaders, responseData } from '../shared/utils'

export function getMaintenanceMode() {
  return fetchWithHeaders('/maintenance', {
    method: 'GET',
  }).then(responseData)
}
